import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { WIDGET_DATA_ENTITY_NAME } from '../const';
import { WidgetDataState } from '../models';

@Injectable({ providedIn: 'root' })
export class WidgetDataStore extends EntityCollectionServiceBase<WidgetDataState> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
    super(WIDGET_DATA_ENTITY_NAME, serviceElementsFactory);
  }
}
